import { createCRUDHook } from './createCRUDHook';
import { BrushDto } from 'utils/models';
import { TBL_BRUSH } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<BrushDto>({
  entityName: 'Brush',
  endpoint: TBL_BRUSH,
});

export const BrushContext = Context;
export const useBrushManager = useManager;
export const useBrush = useConsumer;
